import React, { useEffect, useRef, useState } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import Toast from 'react-native-toast-message'

const GaInformationForm = ({ navigation, route }: any): JSX.Element => {
  const formikRef = useRef(null)
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey,
    maritalStatuses
  } = params

  const intializeStore = useInitializeStore()

  const { loading, postgaonline } = useFormsStore()
  const initializestore = useInitializeStore()
  const personalstore = usePersonalStore()

  const [totalDeductions, setTotalDeductions] = useState(null)

  const options1 = [
    { key: 1, value: 'Single' },
    {
      key: 2,
      value:
        'Married Filing Seperate or Married Filing Joint,both spouses working'
    },
    { key: 3, value: 'Married Filing Joint, one spouse working' },
    { key: 4, value: 'Head of Household' }
  ]

  const options2 = [
    { key: 1, value: 'I claim exemption from withholding because I incurred no Georgia income tax liability last year and I do not expect to have a Georgia income tax liability this year' },
    { key: 2, value: 'Certify that I am not subject to Georgia withholding because I meet the conditions set forth under the Servicemembers Civil Relief Act as provided on page 2.' }
  ]
  // useEffect(() => {
  //   getmodetails(initializestore?.initializeData?.userkey)
  // }, [])

  const handlesubmit = async (values) => {
    const data = {
      essUserOnBoardingFormKey: essUserOnBoardingFormKey,
      essObKey: essUserOnBoardingKey,
      completeOnline: mode === 'upload' ? false : true,
      essUserKey: intializeStore.initializeData?.userkey,
      entityId: personalstore.personalData?.entityId,
      filingStatus: letterUsed,
      dependentAllowances: values.dependentAllowances ? values.dependentAllowances : null,
      georgiaAdjustmentsAllowance: values?.georgiaAdjustmentsAllowance ? values?.georgiaAdjustmentsAllowance : null,
      additionalWithholding: values.additionalwithholding ? values.additionalwithholding : null,
      totalAllowances: total,
      incomeTaxLiability: Number(values.incomeTaxLiability) || null,
      userState: values.userState ? values.userState : null,
    }
    const response: any = await postgaonline(data)
    if (response?.success === true) {
      if (mode === 'online') {
        navigation.navigate('GAInformationOnline', {
          essUserOnBoardingKey,
          essUserOnBoardingFormKey,
          values,
          completeOnline: mode === 'upload' ? false : true,
          total,
          letterUsed
        })
      } else {
        await Toast.show({
          type: 'success',
          position: 'bottom',
          text1: response?.message,
          visibilityTime: 3000,
          autoHide: true,
          topOffset: 60,
          onHide: () => {
            navigation.replace('OnboardingForms')
          }
        })
      }
    } else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }
  const intialValues = {
    filingStatus: '',
    dependentAllowances: '',
    georgiaAdjustmentsAllowance: '',
    additionalwithholding: '',
    totalAllowances: '',
    claimexemption: '2',
    incomeTaxLiability: null,
    userState: '',
  }

  const w4schema = () => {
    const baseSchema = {
      filingStatus: yup.string().required('Filing Status is a required field'),
      dependentAllowances: yup.string().nullable(),
      georgiaAdjustmentsAllowance: yup.string().nullable(),
      additionalwithholding: yup.string().nullable(),
      incomeTaxLiability: yup.string().nullable(),
      userState: yup
        .string()
        .when('incomeTaxLiability', (incomeTaxLiability: any, schema) => {
          if (incomeTaxLiability == '2') {
            return schema.required('State of Residence is a required field')
          }
          return schema.nullable()
        }),
    }
    return yup.object(baseSchema)
  }
  const schema = w4schema()


  let total = null
  let letterUsed = null

  const computevalues = (values) => {
    switch (values.filingStatus) {
      case 0:
        letterUsed = 'A'
        break
      case 1:
        letterUsed = 'B'
        break
      case 2:
        letterUsed = 'C'
        break
      case 3:
        letterUsed = 'D'
        break
    }
    total = Number(values?.dependentAllowances) + Number(values?.georgiaAdjustmentsAllowance)
  }

  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'GA Withholding Taxation'}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={schema}
          onSubmit={async (values, actions) => {
            computevalues(values)
            await handlesubmit(values)
          }}
        >
          {(props) => (
            <>
              <Card>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Filing Status *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Filing Status"
                      options={options1}
                      selectedOption={mapSelectValue(
                        options1,
                        props.values.filingStatus
                      )}
                      onSelect={(option: any) => {
                        props.setFieldValue('filingStatus', option - 1)
                      }}
                      textColor="primary"
                    />
                    {props.touched.filingStatus &&
                      props.errors.filingStatus && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.filingStatus}
                        </Text>
                      )}
                  </View>
                </View>

                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '70%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Enter Dependent Allowances'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.dependentAllowances}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('dependentAllowances')(text)
                        }
                      }}
                    />
                    {props.touched.dependentAllowances &&
                      props.errors.dependentAllowances && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.dependentAllowances}
                        </Text>
                      )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ width: '70%', justifyContent: 'center' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Enter Georgia Adjustment Allowances'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.georgiaAdjustmentsAllowance}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('georgiaAdjustmentsAllowance')(
                            text
                          )
                        }
                      }}
                    />
                    {props.touched.georgiaAdjustmentsAllowance &&
                      props.errors.georgiaAdjustmentsAllowance && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.georgiaAdjustmentsAllowance}
                        </Text>
                      )}
                  </View>
                </View>

                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Claim Exemption'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Claim Exemption"
                      options={options2}
                      selectedOption={mapSelectValue(
                        options2,
                        props.values.incomeTaxLiability
                      )}
                      onSelect={(option: any) => {
                        props.setFieldValue('incomeTaxLiability', option)
                        props.setFieldValue('userState', '')
                        props.setFieldValue('additionalwithholding', '')
                      }}
                      textColor="primary"
                    />
                    {props.touched.incomeTaxLiability &&
                      props.errors.incomeTaxLiability && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.incomeTaxLiability as string}
                        </Text>
                      )}
                  </View>
                </View>

                {!props.values.incomeTaxLiability && (
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ width: '70%', justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'Enter Additional Withholding'}
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.additionalwithholding}
                        keyboardType="numeric"
                        onChangeText={(text) => {
                          if (text === '' || /^\d+$/.test(text)) {
                            props.handleChange('additionalwithholding')(
                              text
                            )
                          }
                        }}
                      />
                      {props.touched.additionalwithholding &&
                        props.errors.additionalwithholding && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.additionalwithholding}
                          </Text>
                        )}
                    </View>
                  </View>
                )}
                {props.values.incomeTaxLiability == '2' &&
                  <View
                    style={[
                      globalStyles.hDirection,
                      globalStyles.hBetweenItems,
                      globalStyles.mb2
                    ]}
                  >
                    <View style={{ width: '70%', justifyContent: 'center' }}>
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary
                        ]}
                      >
                        {'Enter State of Residence'}
                      </Text>
                    </View>
                    <View style={{ width: '28%', overflow: 'hidden' }}>
                      <TextInput
                        style={[globalStyles.input, globalStyles.inputLight]}
                        value={props.values.userState}
                        onChangeText={(text) => {

                          props.handleChange('userState')(text)

                        }}
                      />
                      {props.touched.userState &&
                        props.errors.userState && (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.userState}
                          </Text>
                        )}
                    </View>
                  </View>
                }
                {loading ? (
                  <ActivityIndicator />
                ) : (
                  <View style={{ margin: 10 }}>
                    <CustomButton
                      text={mode === 'upload' ? 'Submit Information' : 'Next'}
                      onPress={props.handleSubmit}
                    />
                  </View>
                )}
              </Card>
            </>
          )}
        </Formik>
      </View>

    </KeyboardAwareScrollView>
  )
}
export default GaInformationForm
